import React from 'react';
import { useDispatch } from 'react-redux';
import {
  Box,
  Stack,
  Paper,
  Avatar,
  Typography,
} from '@mui/material';
import { Email as EmailIcon, ArrowBack as ArrowBackIcon } from '@mui/icons-material';
import {
  PrimaryLoadingButton,
  PrimaryLiteButton,
} from 'components';
import { mfaSliceActions } from 'base/mfa/slice';

interface Props {
  onBackToSignIn: () => void;
}

const MfaSelectConfigEmail: React.FC<Props> = ({ onBackToSignIn }) => {
  const dispatch = useDispatch();

  const handleContinue = () => {
    dispatch(mfaSliceActions.initiateMfaChallenge({ mfaType: 'EMAIL' }));
  };

  return (
    <Box sx={{ width: '100%' }}>
      <Stack spacing={3}>
        <Paper
          variant="outlined"
          sx={{
            padding: '1rem',
            display: 'flex',
            alignItems: 'center',
          }}
        >
          <Avatar sx={{ bgcolor: '#9d8336', mr: 2 }}>
            <EmailIcon />
          </Avatar>
          <Box>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 1.5 }}>
              {`Click "Confirm" to receive an email with instructions to set up Multi-Factor Authentication (MFA). Follow the steps provided to complete the setup.
                Once configured, you'll be able to log in securely.`}
            </Typography>
          </Box>
        </Paper>

        <Stack direction="row" justifyContent="space-between" sx={{ mt: 2 }}>
          <PrimaryLiteButton
            startIcon={<ArrowBackIcon />}
            onClick={onBackToSignIn}
            sx={{ minWidth: 140 }}
          >
            Back to Sign In
          </PrimaryLiteButton>

          <PrimaryLoadingButton
            onClick={handleContinue}
            sx={{ minWidth: 120 }}
          >
            Confirm
          </PrimaryLoadingButton>
        </Stack>
      </Stack>
    </Box>
  );
};

export default MfaSelectConfigEmail;
